/* ===========================
   DEV OVERRIDE (param-only; no persistence)
   - On staging/dev without PostHog: add ?ui=radio or ?ui=control
   - On prod with PostHog: override is ignored
=========================== */
(function devOverride() {
  try {
    var uiParam = new URLSearchParams(location.search).get('ui'); // 'radio' | 'control' | null
    if (uiParam === 'radio' || uiParam === 'control') {
      window.__blogFilterUiVariant = uiParam; // only for this page load
      console.debug('blog-filter-ui: using DEV override →', uiParam);
    }
  } catch (e) {}
})();

(function () {
  // Only run on the blog listing URL
  if (location.pathname.indexOf('/insights-resources/blog/') === -1) return;

  // Idempotency guard: don't run twice
  function alreadyApplied() {
    return !!window.__blogFilterUiApplied;
  }
  function markApplied() {
    window.__blogFilterUiApplied = true;
  }

  function enableRadioUI() {
    if (alreadyApplied()) return;

    // Find the list first (most stable selector)
    var list = document.querySelector('.blog-taxonomy-ul.filter-list');
    if (!list) return;

    // Find the correct wrapper for this instance
    var container = (list.closest && list.closest('.search-input-cover')) || document.querySelector('.search-input-cover');
    if (!container) return;

    var toggleBar = container.querySelector('.waystar-filter');

    // Find the surrounding panel flexibly
    var panel = (list.closest && (list.closest('.dropdown-filter') || list.closest('.news-dropdown-filter'))) || list.parentNode;
    if (!panel) return;

    // Marker class for scoped CSS and to signal "applied"
    container.classList.add('blog-filter--radio');

    // 1) Remove dropdown UI bits
    if (toggleBar) toggleBar.style.display = 'none';
    var closeBtn = panel.querySelector('.js-hide-filter.close');
    if (closeBtn && closeBtn.parentElement) closeBtn.parentElement.removeChild(closeBtn);

    // 2) Break the dropdown behavior (prevents outside-click hide)
    panel.classList.remove('dropdown-filter');
    panel.classList.remove('news-dropdown-filter');

    // Force inline layout (not absolute dropdown)
    panel.style.display = 'block';
    panel.style.position = 'static';
    panel.style.visibility = 'visible';
    panel.style.opacity = '1';
    panel.style.height = 'auto';
    panel.style.transform = 'none';
    panel.style.minWidth = 'auto';
    panel.style.padding = '0';

    // 3) Convert to radios (single-select), keep .js-filter-checkbox for existing handlers
    var inputs = list.querySelectorAll('input.js-filter-checkbox[type="checkbox"]');
    for (var i = 0; i < inputs.length; i++) {
      var cb = inputs[i];

      // Remove theme's hidden checkbox style class
      cb.className = cb.className.replace(/\bstyled-checkbox\b/g, '').trim();

      // Flip to radio; if browser blocks, replace node
      var replaced = false;
      try { cb.setAttribute('type', 'radio'); cb.type = 'radio'; }
      catch (e) {
        var radio = document.createElement('input');
        radio.setAttribute('type', 'radio');
        radio.setAttribute('name', 'blog-filter-category');
        radio.className = cb.className; // keeps js-filter-checkbox, etc.
        radio.id = cb.id;
        radio.value = cb.value;

        // Copy attributes: data-* and nonstandard "data" (your template uses data="category")
        for (var j = 0; j < cb.attributes.length; j++) {
          var attr = cb.attributes[j];
          if (!attr || !attr.name) continue;
          if (attr.name.indexOf('data-') === 0 || attr.name === 'data') {
            radio.setAttribute(attr.name, attr.value);
          }
        }

        if (cb.checked) radio.checked = true;
        cb.parentNode.insertBefore(radio, cb);
        cb.parentNode.removeChild(cb);
        cb = radio;
        replaced = true;
      }

      // Ensure same group name for single-select
      cb.setAttribute('name', 'blog-filter-category');
      cb.style.marginRight = '8px';

      // Safari sometimes needs explicit checked normalization after type flip
      if (!replaced && cb.checked) {
        cb.checked = true;
      }
    }

    // 4) Simple in-place layout (minimal inline styles; your CSS can refine)
    list.style.listStyle = 'none';
    list.style.paddingLeft = '0';
    var items = list.querySelectorAll('li.product-list-li');
    for (var k = 0; k < items.length; k++) {
      var li = items[k];
      li.style.display = 'flex';
      li.style.alignItems = 'center';
      li.style.margin = '4px 0';
    }

    // 5) Keep CLEAR, remove the hide/Apply button
    var actions = panel.querySelector('.js-filter-actions');
    if (actions) {
      var hideBtn = actions.querySelector('.js-hide-filter');
      if (hideBtn && hideBtn.parentElement) hideBtn.parentElement.removeChild(hideBtn);
      var clearBtn = actions.querySelector('.js-clear-filter');
      if (clearBtn) clearBtn.style.marginTop = '8px';
    }

    markApplied();
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

    function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Apply the UI if the flag says "radio"
  function applyIfRadio() {
    try {
      if (!window.posthog || typeof posthog.getFeatureFlag !== 'function') return false;
      var variant = posthog.getFeatureFlag('blog-filter-ui'); // "radio" | "control" | null
      if (variant === 'radio') onReady(enableRadioUI);
      return true;
    } catch (e) { return false; }
  }

  // Try to hook into PostHog when it's available
  function tryHookPosthog() {
    if (!window.posthog) return false;
    try {
      if (typeof posthog.onFeatureFlags === 'function') {
        posthog.onFeatureFlags(function () { applyIfRadio(); });
      }
      // Also do an immediate check in case flags are already loaded
      applyIfRadio();
      return true;
    } catch (e) { return false; }
  }

  // DEV/Stage override (no PostHog): param-only
  var devOverrideVariant = (window.posthog ? null : (window.__blogFilterUiVariant || 'control'));
  if (!window.posthog && devOverrideVariant === 'radio') {
    console.debug('blog-filter-ui: PostHog missing; applying radio via DEV override');
    onReady(enableRadioUI);
  }

  // Final bootstrap: hook now, or poll briefly until PostHog is ready
  if (!tryHookPosthog()) {
    var attempts = 0, maxAttempts = 50; // ~10s at 200ms
    var iv = setInterval(function () {
      if (window.__blogFilterUiApplied) { clearInterval(iv); return; }
      if (tryHookPosthog()) { clearInterval(iv); return; }
      attempts++;
      if (attempts >= maxAttempts) clearInterval(iv);
    }, 200);
  }
})();

